<script>
import { Line, mixins } from 'vue-chartjs'
export default {
    name: 'barsGraph',
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: [
        'options',
        'chartData'
    ],

    computed: {
        coisa(){
            return this.chartData
        },

        toolbar(){
            return this.options
        }
    },

    methods: {
        render(){
            this.renderChart(this.coisa, this.chartOptions)
        }
    },

    mounted () {
        this.render()
    },

    watch: {
        chartData: function(){
            this._chart.destroy()
            this.render()
        }
    }
}
</script>